import { ADD_ROW, GET_ALL_SHEETS, DELETE_ROW, GET_ONE_SHEET, SET_ERROR, SET_LOADING, ADD_ROW_SUCCESS, SAVE_SHEET,} from "../ActionTypes/TechnicalSheetVTypes";

const initialState = {
  sheets: [],
  rows: [],
  savedSheets: [],
  selectedSheet: null,
  loading: false,
  error: null,
};

const technicalSheetVReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_ROW:
      return {
        ...state,
        rows: [...state.rows, action.payload],
      };
    case ADD_ROW_SUCCESS:
  return {
    ...state,
    rows: [...state.rows, action.payload],
    loading: false,
  };
  case SAVE_SHEET:
    return {
      ...state,
      savedSheets: [...state.savedSheets, action.payload],
      rows: [], // Réinitialiser les lignes après sauvegarde
    };
    case GET_ALL_SHEETS:
      return {
        ...state,
        sheets: action.payload,
        error: null,
      };
    case DELETE_ROW:
      return {
        ...state,
        sheets: state.sheets.filter((sheet) => sheet._id !== action.payload),
        error: null,
      };
    case GET_ONE_SHEET:
      return {
        ...state,
        selectedSheet: action.payload,
        error: null,
      };
    case SET_LOADING:
      return {
        ...state,
        loading: action.payload,
      };
    case SET_ERROR:
      return {
        ...state,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default technicalSheetVReducer;
